// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kmiqihcqitsjpiqkfbxv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImttaXFpaGNxaXRzanBpcWtmYnh2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg2NTY5NTgsImV4cCI6MjA2NDIzMjk1OH0._38v3pz-0j1JHRoJ8V6VydO1aa63oEjWXEMJLma-WmM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);